import { Input } from 'antd'

import Styled from './styled'

export default function MyTextArea(props) {
  const textareaProps = {
    ...props,
  }

  return (
    <Styled className="text-area-component">
      <Input.TextArea {...textareaProps} />
    </Styled>
  )
}
